import api from "../http";
const REACT_APP_TC_AUTH = process.env.REACT_APP_TC_AUTH;
const FetchZipCode = (zipCode) => {
  return new Promise((resolve, reject) => {
    api.get(`${REACT_APP_TC_AUTH}/api/CityStateZip/FindCityStateZipByZip/${zipCode}`)
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export default FetchZipCode
